import React, { useRef } from 'react';
import { useLocation } from 'react-router-dom';

const VIDEO_SRC =
  'https://ntrepid-bucketc13d4-dev.s3.us-east-1.amazonaws.com/video/Flexibag.mp4';


function Header() {
  const location = useLocation();
  const isHome = location.pathname === '/';
  const videoRef = useRef(null);

  const getPageTitle = () => {
    switch (location.pathname) {
      case '/': return 'Home';
      case '/about': return 'About';
      case '/all': return 'All Products';
      case '/men': return 'Men';
      case '/Women': return 'Women';
      case '/Children': return 'Children';
      case '/accessories_collectibles': return 'Accessories / Collectibles';
      case '/cart': return 'Shopping Cart';
      default: return '';
    }
  };

  return (
    <header className="bg-dark py-4">
      <div className="container">
        <div
          className={`d-flex flex-column flex-md-row align-items-center ${
            isHome ? '' : 'justify-content-center'
          }`}
        >
          {/* ─── Logo / title block ─── */}
          <div
            className={`text-white text-center ${
              isHome ? 'flex-fill' : ''
            } mb-4 mb-md-0`}
          >
            <img
              src="assets/LogoSymbol.jpg"
              alt="Ntrepid Design logo"
              style={{ maxWidth: '120px' }}
              className="mb-3"
            />
            <h1 className="display-5 fw-bolder m-0">Ntrepid Design</h1>
            <p className="lead text-white-50 mb-1">You're Unique. Embrace It!</p>
            <h2 className="h5 page-title">{getPageTitle()}</h2>
          </div>

          {/* ─── Featured video (home only) ─── */}
          {isHome && (
            <div className="flex-fill d-flex justify-content-center">
              <video
                ref={videoRef}
                className="w-100 rounded shadow"
                style={{ maxHeight: '280px', objectFit: 'cover' }}
                src={VIDEO_SRC}
                preload="metadata"
                controls
                playsInline
                // Optional: trim UI options
                // controlsList="nodownload"
                aria-label="Play Flexibag product video"
              />
            </div>
          )}
        </div>
      </div>
    </header>
  );
}

export default Header;
